import { Component, Input } from '@angular/core';
import DataListConfig from './data-list.config';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'data-list',
  imports: [CommonModule],
  templateUrl: './data-list.component.html',
  styleUrl: './data-list.component.scss'
})
export class DataListComponent {
  @Input() config?: DataListConfig;

  constructor() {
  }

  isEven(index: number): boolean {
    return index % 2 === 0;
  }

  isEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }
}
